'use strict';

// Transparent image
const placeholderImage = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

export default function saSrcPlaceholder() {
  return {
    restrict: 'A',
    link: function ($scope, $element) {
      $element.attr('src', placeholderImage);
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/directives/src_placeholder.js